
const Education = () => {
  return (
    <section className="resumeStyling">
          <h1>Education</h1>
          <div className="eduWork">
            <h2>Full Stack Web Development Bootcamp</h2>
            <p className="divider">June 2022 - September 2022</p>
            <h2>South High School</h2>
            <p className="divider">Graduated in June 2017</p>
          </div>
        </section>
  )
}

export default Education